import { useMediaQuery } from 'react-responsive';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
// Import your action creators
import { saveAmendmentData, setStep } from '../../redux/actions';

function AmendDateChange({ formId, selectedIndex, step }) {

  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const amendmentData = useSelector((state) => {
    const amendments = state?.amendment?.amendExtend?.contracts?.[selectedIndex]?.amendments;
    return amendments?.[amendments.length - 1].amendmentData;
  });
  const formData = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex]);  

  // State hooks for form fields (assuming they are part of amendmentData)
  const [lastContractDate, setLastContractDate] = useState(amendmentData && amendmentData.lastContractDate);
  const [buyer1FirstName, setBuyer1FirstName] = useState(amendmentData && amendmentData.buyer1FirstName);
  const [buyer1LastName, setBuyer1LastName] = useState(amendmentData && amendmentData.buyer1LastName);
  const [buyer1Email, setBuyer1Email] = useState(formData?.data?.buyer1Email);
  const [buyer2FirstName, setBuyer2FirstName] = useState(amendmentData && amendmentData.buyer2FirstName);
  const [buyer2LastName, setBuyer2LastName] = useState(amendmentData && amendmentData.buyer2LastName);
  const [buyer2Email, setBuyer2Email] = useState(formData?.data?.tenants?.[0]?.tenantEmail);
  const [seller1Name, setSeller1Name] = useState(amendmentData && amendmentData.seller1Name); 
  const [seller2Name, setSeller2Name] = useState(amendmentData && amendmentData.seller2Name); 
  const [listingAgentName, setListingAgentName] = useState(amendmentData && amendmentData.listingAgentName); 
  const [listingAgentEmail, setListingAgentEmail] = useState(amendmentData && amendmentData.listingAgentEmail); 
  const [amendmentId, setAmendmentId] = useState(amendmentData && amendmentData.amendmentId);
  const [contractCompletionDate, setContractCompletionDate] = useState(amendmentData && amendmentData.contractCompletionDate);
//   const [amendmentDate, setAmendmentDate] = useState(amendmentData && amendmentData.amendmentDate);
  const [amendmentDate, setAmendmentDate] = useState(new Date());
  const [expirationDate, setExpirationDate] = useState(amendmentData ? amendmentData.expirationDate : '');  
  const [currentDates, setCurrentDates] = useState(amendmentData && amendmentData.currentDates || {});
  const [newDates, setNewDates] = useState(amendmentData && amendmentData.newDates || {});
  // const [newDates, setNewDates] = useState({});
  // const [otherDatesText, setOtherDatesText] = useState(amendmentData ? amendmentData.otherDatesText : '');
  // const [otherAmendmentsText, setOtherAmendmentsText] = useState(amendmentData ? amendmentData.otherAmendmentsText : '');
  const [otherDatesText, setOtherDatesText] = useState('');
  const [otherAmendmentsText, setOtherAmendmentsText] = useState('');
  const [sendToSeller, setSendToSeller] = useState('yes');
  const [packetDetails, setPacketDetails] = useState({});
  const [propertyDescription, setPropertyDescription] = useState(
    amendmentData?.propertyDescription || 
    formData?.propertyData?.data?.lotInfo?.legalDescription || 
    formData?.data?.propertyDescription
  );
  const [address, setAddress] = useState(amendmentData && amendmentData.address);
  const [county, setCounty] = useState(
    amendmentData?.county ||
    formData?.propertyData?.data?.ownerInfo?.mailAddress?.county ||
    formData?.data?.propertyCounty
  );

    // // Function to calculate dayOfWeek
    // function calculateDayOfWeek(dateValue) {
    //     let dayOfWeek = '';
    //     if (dateValue !== 'N/A') {
    //     const [year, month, day] = dateValue.split('-');
    //     const dateObject = new Date(year, month - 1, day);
    //     dayOfWeek = dateObject.toLocaleDateString('en-US', { weekday: 'long' });
    //     }
    //     return dayOfWeek;
    // }; 


    // useEffect(() => {
    //     // Check if newDates is empty and only then set it based on currentDates
    //     if (Object.keys(newDates).length === 0) {
    //       const transformedDates = Object.entries(currentDates).reduce((acc, [key, value]) => {
    //         acc[key] = {
    //           date: value,
    //           isChanged: false,
    //           isDeleted: false,
    //         };
    //         return acc;
    //       }, {});
    //       setNewDates(transformedDates);
    //     }
    //   }, [currentDates]); // Remove newDates from dependency array

    // console.log("Buyer 1 Email", buyer1Email, "Buyer 2 Email", buyer2Email);
    
      const handleDelete = (key) => {
        setNewDates(prevDates => ({
            ...prevDates,
            [key]: {
                ...prevDates[key],
                isDeleted: !prevDates[key].isDeleted, // Toggle the isDeleted state
                isChanged: false
            }
        }));
    };
    
    const handleNewDate = (name, newDate) => {
        setNewDates(prevDates => {
          // Check if newDate is an object and contains isDeleted property
          if (typeof newDate === 'object' && newDate.hasOwnProperty('isDeleted')) {
            return {
              ...prevDates,
              [name]: {
                ...prevDates[name],
                isDeleted: newDate.isDeleted,
                isChanged: false, // Assuming you want to reset isChanged when isDeleted is toggled
              }
            };
          } else {
            // Handle the case for updating date
            return {
              ...prevDates,
              [name]: {
                ...prevDates[name],
                date: newDate,
                isChanged: true,
                isDeleted: false // Reset isDeleted when a new date is set
              }
            };
          }
        });
      };

      function convertTo12Hour(time) {
        if (!time || typeof time !== 'string') {
            return '';
        }
    
        const [timePart, initialPeriod] = time.split(' ');
        let hours, minutes;
        let period = initialPeriod;
    
        if (period) {
            // Handle 12-hour format with AM/PM
            [hours, minutes] = timePart.split(':').map(Number);
            if (period === 'PM' && hours < 12) {
                hours += 12;
            } else if (period === 'AM' && hours === 12) {
                hours = 0;
            }
        } else {
            // Handle 24-hour format
            [hours, minutes] = time.split(':').map(Number);
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
        }
    
        // Ensure minutes are always two digits
        minutes = minutes < 10 ? `0${minutes}` : minutes;
    
        return `${hours}:${minutes} ${period}`;
    }
    
    const formatDate = (dateString) => {
        // Check if the dateString is a time in HH:MM:SS format
        if (/^\d{2}:\d{2}:\d{2}$/.test(dateString)) {
            return dateString; 
        }
    
        // Check if the dateString is a time in HH:MM AM/PM format
        if (/^\d{1,2}:\d{2} (AM|PM)$/.test(dateString)) {
            return convertTo12Hour(dateString);
        }
    
        // If not, try to parse it as a date
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            // If the date is not valid, return an empty string or handle the error in another way
            return "N/A";
        }
    
        // If the date is valid, format it as an ISO string and return it
        return date.toISOString().split('T')[0];
    };

    const formatDateForMobile = (dateString) => {
        // Check if the dateString is a time in HH:MM:SS format
        if (/^\d{2}:\d{2}:\d{2}$/.test(dateString)) {
            return dateString;
        }
    
        // If not, try to parse it as a date
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            // If the date is not valid, return an empty string or handle the error in another way
            return "N/A";
        }
    
        // If the date is valid, format it as mm/dd
        let month = '' + (date.getMonth() + 1),
            day = '' + date.getDate();
    
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
    
        return [month, day].join('/');
    };

    const formatName = (name) => {
        // Split the name into words
        let words = name.split('_');
    
        // Remove the last word if it is "deadline"
        if (words[words.length - 1].toLowerCase() === "deadline") {
            words.pop();
        }
    
        // Capitalize the first letter of each word and join them with spaces
        return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    // For displaying current deadlines correctly across timezones
    const displayDateCorrectly = (dateString) => {
        const date = new Date(dateString);
        date.setHours(date.getHours() + 12); // Avoid timezone issues by setting time to noon
        return isMobile ? formatDateForMobile(date) : formatDate(date);
    };
      
  const handleSave = () => {
    const amendmentDateString = amendmentDate.toISOString();
    // Construct the amendmentData object from local state
    const updatedAmendmentData = {
      lastContractDate: lastContractDate,
      buyer1FirstName: buyer1FirstName,
      buyer1LastName: buyer1LastName,
      buyer1Email: buyer1Email,
      buyer2FirstName: buyer2FirstName,
      buyer2LastName: buyer2LastName,
      buyer2Email: buyer2Email,
      seller1Name: seller1Name, 
      seller2Name: seller2Name, 
      listingAgentName: listingAgentName,
      listingAgentEmail: listingAgentEmail,
      contractCompletionDate: contractCompletionDate,
      amendmentDate: amendmentDateString, 
      amendmentId: amendmentId,
      expirationDate: expirationDate,
      currentDates: currentDates,
      newDates: newDates,
      otherDatesText,
      otherAmendmentsText,
      sendToSeller: sendToSeller,
      packetDetails,
      propertyDescription: propertyDescription,
      address: address,
      county: county,

      // Include other fields as necessary
    };
    dispatch(saveAmendmentData(formId, updatedAmendmentData));
  };

  const prevStep = () => {
    dispatch(setStep(step - 1)); // Dispatch action to update step in the Redux store
};

const nextStep = () => {
        handleSave(); // Save the amendment data before proceeding
        dispatch(setStep(step + 1)); // Ensure setStep returns a plain object     
}; 

      // Update state when amendmentData changes
      useEffect(() => {
        if (amendmentData) {
          setCurrentDates(amendmentData.currentDates || {});
          setNewDates(amendmentData ? amendmentData.newDates : {});
        }
      }, [amendmentData]);

      // console.log("New Dates", newDates);

    // if (isLoading) {
    //     return <p>Loading...</p>;
    // } 
    return (
        <div className='flex flex-col max-h-450px'> 
        <div className='w-[375px] md:w-[750px] max-h-[calc(100vh-350px)] overflow-y-auto px-4'>
            <div className='flex flex-col justify-start'>
                <div className='inline-flex justify-between w-[330px] md:w-full items-center'>
                    <h1 className='text-[14px] md:text-lg text-black font-[Inter] mb-2'>Add Any Amended Dates</h1>
                    {/* <button className='text-shi-green font-[Inter] text-[14px] md:text-lg mr-10 md:mr-1' onClick={handleSave}>Save</button> */}
                </div>
                <h1 className='text-slate-700 font-[Inter] mt-2 md:mt-0 text-[12px] md:text-[16px] mb-6 w-[300px] md:w-[550px]'>If there is no change, then leave the Amended Deadline Blank. If you are deleting a deadline then select the accompanying checkbox</h1>
                <span className='text-slate-700 font-[Inter] mt-2 md:mt-0 text-[12px] md:text-[16px] mb-6 w-[300px] md:w-[550px]'><b>IMPORTANT:</b> Be careful of amending to a date that is a federal or state holiday as it may impact the ability to meet certain deadline's on a holiday</span>
            </div>
            <table className="border-separate border-spacing-0">
                <thead>
                    <tr className=''>
                        <th className='w-[160px] md:w-[320px] text-start text-[12px] md:text-[16px]'>Deadline Name</th>
                        <th className='w-[150px] text-start text-[12px] md:text-[16px]'>Current Deadline</th>
                        <th className='w-[125px] md:w-[150px] text-center md:text-start text-[12px] md:text-[16px]'>Amended Deadline</th>
                        <th className='w-[150px] text-end ml-[25px] text-[12px] md:text-[16px]'>Delete Deadline</th>
                    </tr>
                </thead>
                <tbody className=''>
                    {Object.entries(newDates.length > 0 ? newDates : currentDates)
                        .filter(([key]) => key.toLowerCase() !== 'closingtimeframe') // Ignore "ClosingTimeframe"
                        .map(([key, value]) => (
                        
                        <tr key={key}>
                            <td className='text-[11px] md:text-[16px] border-transparent border-b-8'>{formatName(key)}</td>
                            <td className='justify-start w-[200px] text-[11px] text-center md:text-[16px] border-transparent border-b-8'>
                                {key.toLowerCase().includes('time') ? (
                                    <span>{convertTo12Hour(value)}</span>
                                ) : (
                                    <span>{isMobile ? displayDateCorrectly(value) : formatDate(value)}</span>
                                )}
                            </td>
                            <td className='justify-start w-[200px] border-transparent border-b-8'>
                                <input 
                                    type={key.toLowerCase().includes('time') ? "time" : "date"} 
                                    name={key} 
                                    value={newDates[key]?.date || ''} 
                                    className={`py-1 px-3 h-[39px] text-[11px] md:text-[16px] rounded-md border border-slate-200 w-[110px] md:w-full`}  
                                    onChange={(e) => handleNewDate(e.target.name, e.target.value)} 
                                />
                            </td>
                            <td className='w-[50px] md:w-[150px] md:text-center text-end md:pl-10 border-transparent border-b-8'>
                                <input 
                                    type="checkbox" 
                                    checked={newDates[key]?.isDeleted || false} // Ensure this matches the state
                                    onChange={() => {
                                        if (!newDates[key]) {
                                            // Initialize newDates[key] as an empty object if it doesn't exist
                                            handleNewDate(key, {isDeleted: true});
                                        } else {
                                            // If newDates[key] exists, toggle the isDeleted property
                                            handleDelete(key);
                                        }
                                    }} 
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
            <div className="flex w-full justify-center gap-10 md:gap-36 mt-4 bg-white">
                <button 
                  className={`w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-start flex`} 
                  onClick={prevStep}
                    >Back
                </button>
                <button 
                  className={`w-[100px] md:w-[150px] justify-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 items-start flex`}
                  onClick={nextStep}
                    >Next
                </button>
            </div>
        
        </div>
    ); 
}

export default AmendDateChange;